import { getState, setState, subscribe } from './state';


const audioCtx = new AudioContext();

const oscillator = audioCtx.createOscillator();
const gain = audioCtx.createGain();
const panner = audioCtx.createStereoPanner();
const filter = audioCtx.createBiquadFilter();

gain.gain.value = getState().amplitude;
panner.pan.value = getState().pan;

oscillator.type = getState().type;
oscillator.frequency.value = getState().frequency;

filter.type = 'lowpass';
filter.frequency.value = audioCtx.sampleRate / 2;

oscillator.connect(filter);
filter.connect(gain);
gain.connect(panner);
panner.connect(audioCtx.destination);

function toggle() {
  if (!getState().connected) {
    panner.connect(audioCtx.destination);
  } else {
    panner.disconnect(audioCtx.destination);
  }

  const state = {
    connected: !getState().connected
  };

  if (!getState().playing) {
    state.playing = true;
    oscillator.start();
  }

  setState(state);
}

document.querySelector('.toggle').addEventListener('click', toggle);

const btnEls = document.querySelectorAll('.state-btn');

for (let i = 0; i < btnEls.length; i++) {
  btnEls[i].addEventListener('click', onStateBtn);
}

function onStateBtn(e) {
  const { state, value } = e.target.dataset;

  setState({
    [state]: value
  });
}

const rangeEls = document.querySelectorAll('.state-range');

for (let i = 0; i < rangeEls.length; i++) {
  rangeEls[i].addEventListener('input', onStateRange);
  const { state } = rangeEls[i].dataset;
  rangeEls[i].value = getState()[state];
  setCustomProperty(rangeEls[i]);

  if (state === 'filterFrequency') {
    rangeEls[i].setAttribute('max', audioCtx.sampleRate / 2);
  }
}

function setCustomProperty(el) {
  const perc = (el.value - el.min) / (el.max - el.min);
  el.parentElement.style.setProperty('--percentage', perc);
}

function onStateRange(e) {
  const { state } = e.target.dataset;
  setCustomProperty(e.target);

  setState({
    [state]: e.target.value
  });
}

subscribe(oldState => {
  const { type, frequency, pan, amplitude, filterFrequency, filterQuality } = getState();
  const { currentTime: ct } = audioCtx;

  if (type !== oldState.type) {
    oscillator.type = type;

    document.querySelector(`.active`).classList.remove('active');
    document.querySelector(`[data-value=${ type }]`).classList.add('active');
  }

  if (frequency !== oldState.frequency) {
    oscillator
      .frequency
      .value = frequency;
  }

  if (amplitude !== oldState.amplitude) {
    gain
      .gain
      .linearRampToValueAtTime(amplitude, ct + 0.2);
  }

  if (pan !== oldState.pan) {
    panner
      .pan
      .linearRampToValueAtTime(amplitude, ct + 0.05);
  }

  if (filterFrequency !== oldState.filterFrequency) {
    filter
      .frequency
      .value = filterFrequency;
  }

  if (filterQuality !== oldState.filterQuality) {
    filter
      .Q
      .linearRampToValueAtTime(filterQuality, ct + 0.05);
  }
});
